/**
 * Enumerador que representa la severidad de una notificación
 */
export enum AppNotificationSeverity {
  SUCCESS = 'success',
  INFO = 'info',
  WARNING = 'warn',
  ERROR = 'error'
}
